class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  async renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    const sections = parsedState.sections || {};
    let productRendered = false;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      if (!target) return;

      const sectionHtml =
        section.id === 'cart-notification-product'
          ? this.getProductSectionInnerHTML(sections[section.id])
          : this.getSectionInnerHTML(sections[section.id], section.selector);

      if (sectionHtml === null) return;
      target.innerHTML = sectionHtml;

      if (section.id === 'cart-notification-product') {
        productRendered = true;
      }
    });

    if (!productRendered) {
      await this.refreshProductSection();
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : null;
  }

  getProductSectionInnerHTML(html) {
    if (!html) return null;
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const item =
      documentFragment.getElementById(`cart-notification-product-${this.cartItemKey}`) ||
      documentFragment.querySelector('.cart-item');
    return item ? item.innerHTML : null;
  }

  async refreshProductSection() {
    const target = document.getElementById('cart-notification-product');
    if (!target) return;

    try {
      const response = await fetch(`${routes.cart_url}?section_id=cart-notification-product`, {
        credentials: 'same-origin',
      });
      if (!response.ok) return;

      const sectionHtml = this.getProductSectionInnerHTML(await response.text());
      if (sectionHtml !== null) {
        target.innerHTML = sectionHtml;
      }
    } catch (error) {
      return;
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
